const MaintenanceNotice = () => {
  return (
    <div className="text-center p-[16px]">
      <p className="text-[18px] font-semibold mb-[8px]">
        🔧 Tính năng đang bảo trì
      </p>

      <p className="text-gray-500">
        Chúng tôi đang nâng cấp hệ thống. Vui lòng quay lại sau hoặc liên hệ
        CSKH nếu cần hỗ trợ.
      </p>
    </div>
  );
};

export default MaintenanceNotice;
